
export default {
  props: {
    photos: Array,
  },
};
